import React from 'react';
import { Task } from '../../../types';
import { calculateColumnCosts, calculateColumnTime } from '../utils/calculations';
import { useKanbanStore } from '../../../store/useKanbanStore';

interface ColumnFooterProps {
  tasks: Task[];
}

export const ColumnFooter: React.FC<ColumnFooterProps> = ({ tasks }) => {
  // Pull visibility toggles from the store
  const showTime = useKanbanStore((state: any) => state.showTime);
  const showCost = useKanbanStore((state: any) => state.showCost);
  const showRawHours = useKanbanStore((state: any) => state.showRawHours);

  const costs = calculateColumnCosts(tasks);
  const time = calculateColumnTime(tasks, showRawHours);

  return (
    <div className="space-y-2 mt-2">
      {/* Time & Cost Summary Card */}
      <div className="p-2 sm:p-3 bg-slate-50 border border-slate-200 text-xs text-slate-600 space-y-1.5 rounded-lg dark:bg-slate-800 dark:border-slate-700 dark:text-slate-300">
        
        {/* Time Breakdown - Only renders if showTime is true */}
        {showTime && (
          <div className="flex flex-wrap justify-between gap-x-2 gap-y-1 items-center font-mono bg-white p-1.5 rounded border border-slate-200 dark:bg-slate-900 dark:border-slate-700">
            <span className="text-slate-500 font-sans dark:text-slate-400">Time:</span>
            <span>
              Est: <strong className="text-slate-800 dark:text-slate-200">{time.formattedEstimated}</strong> | Act:{' '}
              <strong className="text-slate-800 dark:text-slate-200">{time.formattedActual}</strong>
            </span>
          </div>
        )}

        {/* Cost Breakdown per Currency - Only renders if showCost is true */}
        {showCost && (
          Object.keys(costs).length === 0 ? (
            <div className="text-slate-400 italic text-[11px] text-center dark:text-slate-500">No costs logged</div>
          ) : (
            Object.entries(costs).map(([currency, values]) => (
              <div
                key={currency}
                className="flex flex-wrap justify-between gap-x-2 gap-y-1 items-center font-mono bg-white p-1.5 rounded border border-slate-200 dark:bg-slate-900 dark:border-slate-700"
              >
                <span className="text-slate-500 font-sans dark:text-slate-400">Cost ({currency}):</span>
                <span>
                  Est: <strong className="text-slate-800 dark:text-slate-200">{values.estimated.toLocaleString()}</strong> | Act:{' '}
                  <strong className="text-slate-800 dark:text-slate-200">{values.actual.toLocaleString()}</strong>
                </span>
              </div>
            ))
          )
        )}
      </div>
    </div>
  );
};